import { useMemo } from 'react';

import config from '../../../config';
import { LeoResponseMessageContext } from '../../../utils/LeoUtils';
import NeoLeoLink from './NeoLeoLink';

interface NeoLeoTxnOrListingItemsProps {
  msgContext: LeoResponseMessageContext;
}

const NeoLeoTxnOrListingItems: React.FC<NeoLeoTxnOrListingItemsProps> = ({
  msgContext,
}) => {
  const context = msgContext.details?.[0];

  const items = useMemo(
    () =>
      !!context?.items
        ? context?.items.map((item) => ({
            title: item.address!,
            url: `${config.reactAppHostUrl}/${
              context?.type === 'transaction_story'
                ? 'transactions'
                : 'listings'
            }/${item.id}`,
          }))
        : [],
    [context?.items, context?.type],
  );

  return (
    <div className='text-white font-inter flex flex-col gap-3'>
      <div className='flex items-center'>
        <p className='font-medium text-sm'>{context.message}</p>
      </div>
      <div className='text-white font-inter flex flex-col gap-2'>
        {items.map((item) => (
          <NeoLeoLink key={item.url} title={item.title} url={item.url} />
        ))}
      </div>
    </div>
  );
};

export default NeoLeoTxnOrListingItems;
